import * as React from "react";
import { Alert } from "components/bootstrap";
const DataLakeStreamDeleteWarning = () => /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, "Data Lake is enabled on this stream and have data. ", /* @__PURE__ */ React.createElement("br", null), "Please disable it and delete the data before deleting the stream.");
export default DataLakeStreamDeleteWarning;
